import React, { useState, useEffect, useCallback, useRef,useContext } from 'react';
import _ from "lodash";
import {IProps} from './types';
import * as S from './styles';
import { default as D } from '@assets/themes/dimensions';
import Loading from '@components/Loading';
import { SearchIcon } from '@assets/icons/searchIcon';
import { CloseIcon } from '@assets/icons/closeIcon';
import { useDispatch, useSelector } from 'react-redux';
import { reloadListAction } from '@state/openReducers/actions';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { TemplatesContext } from '@utils/DOIgnition/TemplatesContext';
import { AuthContext } from '@utils/DOIgnition/AuthContext';

const Search:React.FC<IProps> = (props) => {
  const authContext = useContext(AuthContext);  
  const userData = authContext && authContext.userData?authContext.userData.profile:undefined;
  const{ setShowList, location, searching, setSearching, setSearchValue , value, forceSearch, setForceSearch, setSearchQuery, deleteId, setCounterQuery, setFiltering, setShowCounter } = useContext(TemplatesContext);
  const [fetchingSearch, setFetchingSearch]= useState(false);
  const [showMenu, setShowMenu]= useState(false);
  const [showLoading, setShowLoading]= useState(false);
  const [showClear, setShowClear]= useState(false);
  const [selected, setSelected] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  //const [value, setValue] = useState(searchValue);
  const [newSearch, setNewSearch] = useState(false);
  const [debouncedState, setDebouncedState] = useState("");
  const componentRef = useRef(null);
  const dispatch = useDispatch();
  const searches = useSelector(selectors.templates.getTemplateSearch);  
  const handleFocus=()=> {
    if((searches)&&(value.length>3))setShowMenu(true);
  };

  const handleChange = (event: any) => {
    setSearchValue(event.target.value);

    if(event.target.value.length>0)setShowClear(true);
    else setShowClear(false);
    
    if(event.target.value.length>3){
      setFetchingSearch(true);
      setShowLoading(true);
      setShowMenu(true);
      debounce(event.target.value);
    }
    
    if(event.target.value.length==0)setShowMenu(false);
  };
  const run = async (_searchVal:string) => {
    await fetchSearch(_searchVal);
  }
  const debounce  = useCallback(
    _.debounce((_searchVal: string) => {
      setDebouncedState(_searchVal);     
      run(_searchVal);	
    }, 400),
    []
  );

  const fetchSearch = (value: string) => {
    let searchQuery=` and (c.formatName LIKE "%${value.toLowerCase()}%" or udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus))`;
    if(location==='studio')searchQuery=` and (c.formatName LIKE "%${value.toLowerCase()}%" or udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus, "PUBLISHED"))`;
    setSearchQuery(searchQuery);

    searchQuery = encodeURIComponent(searchQuery);
    let query=`c.templateStatus<>'INACTIVE' ${searchQuery}&userdata=${JSON.stringify(userData)}&orderby=c.name&start=0&pagelength=20`;
    if(location==='studio')query=`c.templateStatus='PUBLISHED' ${searchQuery}&orderby=c.name&start=0&pagelength=20`;
    
    setCounterQuery(query);

    return new Promise((resolve, reject) => {      
      dispatch(actions.templates.fetchSearch('?filter='+query ,(result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const fetchTemplates = () => {
    let searchQuery=encodeURIComponent(` and (c.formatName LIKE "%${value.toLowerCase()}%" or udf.searchCustomTags(c.tags.customTags, "${value.toLowerCase()}", c.templateStatus))`);
    let query=`?filter=c.templateStatus<>'INACTIVE' ${searchQuery}&userdata=${JSON.stringify(userData)}&orderby=c.templateStatus DESC&start=0&pagelength=20`;
    return new Promise((resolve, reject) => {
      dispatch(actions.templates.fetchTemplates(query,(result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  useEffect(() => {           
    if((searches)&&(value!=='')){      
      setShowLoading(false);
      setNewSearch(true);
      if(value.length>3)setFetchingSearch(false);
      if (forceSearch)
      {
        ejecSearch()
        setForceSearch(false)
      }
    }
    else{
      setShowMenu(false);
      setShowLoading(false);
    }
  }, [searches]);



  useEffect(()=>{    
    if (forceSearch)
    {
      dispatch(reloadListAction(true))
      setShowClear(true);      
      run(value);     
    }
  },[forceSearch]
  )

  useEffect(() => {
    if(searches){
      if(props.deteleItem){
        if(searches.length>0)dispatch(actions.templates.setSearch(searches.filter((item: any) => item.id !== deleteId)));
        setShowMenu(false);
      }
    }
  }, [props.deteleItem]);  

  const handleClickOuside = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if(!ref.contains(e.target)){
          setShowMenu(false);
        }
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleClickOuside);
    return () => document.removeEventListener("click", handleClickOuside);
  }, []);

  useEffect(() => {
    if (!searching && location==='studio') {
      setShowMenu(false);
      //setValue('');
      setSearchValue('');
      setShowClear(false);
      clearSearch();
    }
  }, [searching]);

  const handleClickOption = (event: any, idx:number) => {
    props.onSearchClick();
    dispatch(reloadListAction(true));
    setTimeout(function() {
      dispatch(actions.templates.setTemplates([searches[idx]] as any));
    }, 500);
    setShowMenu(false);
    setSelected(true);
    setShowCounter(false);
    
    if(!searching){
      setSearching(true);
      setShowList(true);
    }
    if(newSearch)loadcounter();
  };
  
  const handleClear = (event: any) => {
    setShowMenu(false);
    setSearchValue('');
    setShowClear(false);
    setForceSearch(false);
    dispatch(actions.templates.setSearch([] as any));
    clearSearch(); 
  }


  const ejecSearch=()=>{
    
    setFiltering(false);
    setSearching(true);
    setShowCounter(true);
    dispatch(reloadListAction(true));    
    if(location==='studio'){
      setTimeout(function() {
        dispatch(actions.templates.setTemplates(searches as any));
      }, 500);
      setShowList(true);
    }
    else{
      const run = async () => {
        await fetchTemplates();
      }
      run();	
    }
    if(!fetchingSearch)setShowMenu(false);
  }


  const handleKeyUp=(e:any)=>{
    if (e.keyCode === 8) { 
      if(e.target.value.length===0)clearSearch();
    }
    else if (e.keyCode === 13) {
      
      if(searches && value.length>3){
        if (searches.length>0 && !fetchingSearch){
            ejecSearch()         
        }
      }

      if(location==="studio")loadcounter();
      else if(location==="templates") setSearchValue(value);
    }
  }

  const clearSearch=()=>{
      setSelected(false);
      setSearching(false);
      setSearchValue('');

      if (location==="studio") {
        if (searching) setShowList(false);
      }
      else{
        if (searching) {
          dispatch(reloadListAction(true));
          let query=`?filter=c.templateStatus<>'INACTIVE'&userdata=${JSON.stringify(userData)}&orderby=c.templateStatus DESC,c.createdDate DESC&start=0&pagelength=20`;
          return new Promise((resolve, reject) => {
            dispatch(actions.templates.fetchTemplates(query, (result: any, error: any) => {
              if (error) reject(error)
              else resolve(result)
            }))
          });
        }
      }
  }

  const loadcounter=()=>{
    if(searches && searches.length>0 && !fetchingSearch && value.length>3)setSearchValue(value);
    props.onSearchClick();
    setNewSearch(false);
    dispatch(actions.templates.setCounter({} as any));
  }

  let width=`calc(44vw - ${D.VERTICAL_MENU_WIDTH + D.LOGOUT_WIDTH}px)`;

  return (
    <S.Root ref={componentRef}>
      <SearchIcon style={{display: 'inline-block', verticalAlign: 'middle', marginLeft: '27px'}}/>
      <S.Col style={{width: width }}>
          <S.InputSearch 
            id="search"
            placeholder="Search Templates..."
            value={value}
            onChange={handleChange}
            onFocus={ handleFocus }
            onClick={ ()=>handleFocus()}
            onKeyUp={(e)=>handleKeyUp(e)} 
            autoComplete="off"
          />
          {showClear &&
          <S.Icon onClick={(e)=>handleClear(e)}>
            <CloseIcon/>
          </S.Icon>}
      </S.Col>
      <S.SearchList style={{display: showMenu?'block':'none'}}>
          <S.OptionsContaine>
              {(searches&&(value.length>3)&&(!showLoading)) && searches.map((template: any, idx: number)=>{

                let tag=null;                
                if (template.formmatName &&!template.formatName.includes(value)){
                  template.tags.customTags.forEach((item: string)=>{
                    if (item.includes(value))tag=<S.Tag>- Tag: {item}</S.Tag>
                  })
                }

                return <S.Option key={`op${idx}`} onClick={(e)=>handleClickOption(e, idx)}>
                         {template.name}
                         {tag}
                      </S.Option>
              })}
              {searches && searches.length===0 && !showLoading &&
                <S.Option>No templates found for your search.</S.Option>
              }
          </S.OptionsContaine>
          {showLoading && <Loading/>}
        </S.SearchList>
    </S.Root>
  );
}

export default Search;